import PropTypes from "prop-types";
import { Col, Row } from "react-grid-system";
import { StyledField } from "../../styles/StyledField";
import { StyledProfileDetailsData } from "../../styles/StyledProfileDetails/StyledProfileDetailsData";
export default function ProfileDetailsData({ data }) {
	const { firstName, lastName, roleInOrganization, phone, email, website, officeAddress, privateAddress, about } = data;

	return (
		<StyledProfileDetailsData>
			<Row>
				<Col sm={12}>
					<h2>Personal data</h2>
				</Col>
			</Row>
			<Row>
				<Col sm={12} lg={6} xl={3}>
					{firstName && (
						<StyledField>
							<label>First name</label>
							<span data-testid="firstName">{firstName}</span>
						</StyledField>
					)}
					{lastName && (
						<StyledField>
							<label>Last name</label>
							<span data-testid="lastName">{lastName}</span>
						</StyledField>
					)}
					{roleInOrganization && (
						<StyledField mb="20px">
							<label>Role in organization</label>
							<span data-testid="roleInOrganization">{roleInOrganization}</span>
						</StyledField>
					)}
					{phone && (
						<StyledField>
							<label>Phone</label>
							<span data-testid="phone">{phone}</span>
						</StyledField>
					)}
					{email && (
						<StyledField>
							<label>Email</label>
							<span data-testid="email">{email}</span>
						</StyledField>
					)}
					{website && (
						<StyledField>
							<label>Website</label>
							<span data-testid="website">{website}</span>
						</StyledField>
					)}
					{officeAddress && (
						<StyledField>
							<label>Office address</label>
							<span data-testid="officeAddress">{officeAddress}</span>
						</StyledField>
					)}
					{privateAddress && (
						<StyledField>
							<label>Private address</label>
							<span data-testid="privateAddress">{privateAddress}</span>
						</StyledField>
					)}
				</Col>
				{about && (
					<Col sm={12} lg={6} offset={{ xl: 3 }}>
						<StyledField>
							<label>About</label>
							<span data-testid="about" className="bigText">
								{about}
							</span>
						</StyledField>
					</Col>
				)}
			</Row>
		</StyledProfileDetailsData>
	);
}

ProfileDetailsData.propTypes = {
	data: PropTypes.object,
};
